import React from 'react'
import { RouterProvider } from 'react-router5'

import Router from './router/Router'

const Root = ({
  router,
}) => {
  return (
    <RouterProvider router={ router }>
      <Router />
    </RouterProvider>
  )
}

export default Root
